import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { GasprecioService } from '../../../gasprecio/services/gasprecio.service';
import { SharedService } from '../../../gasprecio/services/shared.service';
import { Router, Event as NavigationEvent, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-chart-sale-ppc',
  templateUrl: './chart-sale-ppc.component.html',
  styleUrls: ['./chart-sale-ppc.component.scss']
})
export class ChartSalePpcComponent implements OnInit, OnDestroy {

  @ViewChild('chartModalEvol') chartModalEvol: TemplateRef<any>;
  @Input() section: any = false;
  @Input() station: any = false;
  @Input() v2: any = false;
  changeModal;
  changeModal$!: Subscription;
  dataEvol;
  date: any;
  days = 30;
  days$!: Subscription;
  event$!: Subscription;
  fullData;
  idGroup = '60afa99655f4ee369d1df409';
  idGroup$!: Subscription;
  idStation: string;
  idStation$!: Subscription;
  importants;
  importants$: Subscription;
  maxSellingPrice: any;
  maxSellingPrice3: any;
  minSellingPrice: any;
  minSellingPrice3: any;
  suggestedPrice: any;
  months = 12;
  months$!: Subscription;
  nameStation;
  period = 'day';
  period$!: Subscription;
  ppc: any;
  productType = 'regular';
  productType$!: Subscription;
  reqst = 0;
  reqstEvol = 0;
  rol;
  route;
  selectedCluster;
  selectedCluster$!: Subscription;
  selectedCluster2;
  selectedCluster2$!: Subscription;
  selectedCluster3;
  selectedCluster3$!: Subscription;
  selectedCluster4;
  selectedCluster4$!: Subscription;
  sellingPrice;
  showPriceComp = false;
  stationId: any;
  stationId$!: Subscription;
  weeks = 12;
  weeks$!: Subscription;
  zoneSelected = null;
  zoneSelected$: Subscription;
  listDemo = ['650b1770c61e9acd325c8df8', '650b1771c61e9acd325c8e18', '650b1772c61e9acd325c8e38', '650b1773c61e9acd325c8e58', '650b1774c61e9acd325c8e78']
  chartEvolOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      text: `Histórico - Evolución de Precios`,
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        rotation: -60,
        y: 14
      }
    },
    yAxis: {
      title: {
        text: 'Precio de Venta',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        format: '$ {value:.2f}',
        style: {
          fontSize: '12px'
        }
      },
      tickAmount: 10,
      gridLineDashStyle: 'LongDash'
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    tooltip: {
      formatter: function () {
        var tooltip = '<span style="font-size: 10px">' + this.x + '</span><br/>'; // Agrega la categoría en el tooltip
        var currentPoint = this;
        var addedStations = [];
        this.series.chart.series.forEach(function (series) {
          series.points.forEach(function (point) {
            if (point.y === currentPoint.y && point.x === currentPoint['point'].index && !addedStations.includes(series.name)) {
              tooltip += '<span style="color:' + series.color + '">\u25CF</span> ' + series.name + ': <b>$ ' + point.y.toFixed(2) + '</b><br/>';
            }
          });
        });
        return tooltip;
      }
      // pointFormat: '{series.name}: <b>$ {point.y:.2f}</b>'
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 3
        },
        lineWidth: 2
      }
    },
    exporting: {
      filename: `Histórico - Evolución de Precios`,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -6
      }
    },
    series: []
  };

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    credits: {
      enabled: false
    },
    chart: {
      type: 'line'
    },
    title: {
      text: `Precio de Venta - Precio de Competencia`,
      style: {
        fontSize: '0'
      }
    },
    xAxis: {
      categories: [],
      gridLineWidth: 1,
      gridLineDashStyle: 'LongDash',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '0'
        }
      },
      labels: {
        style: {
          fontSize: '11px',
        },
        rotation: -60,
        y: 14
      }
    },
    yAxis: [
      {
        title: {
          text: 'Precio de Venta',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '$ {value:.2f}',
          style: {
            fontSize: '11px'
          }
        },
        tickAmount: 10,
        gridLineDashStyle: 'LongDash'
      },
      {
        title: {
          text: 'Precio de Competencia',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          format: '$ {value:.2f}',
          style: {
            fontSize: '12px'
          }
        },
        tickAmount: 10,
        gridLineDashStyle: 'LongDash'
      }
    ],
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'top',
      itemDistance: 10,
      y: 1,
      padding: 1,
      itemMarginTop: 1,
      itemMarginBottom: 1,
      itemHoverStyle: {
        color: '#00E07B',
      }
    },
    tooltip: {
      split: true,
      pointFormat: '{series.name}: <b>$ {point.y:.2f}</b>'
    },
    plotOptions: {
      series: {
        animation: {
          duration: 1000
        },
        marker: {
          radius: 2
        },
        lineWidth: 2
      }
    },
    exporting: {
      filename: `Precio de Venta - Precio de Competencia`,
      sourceWidth: 1200,
      sourceHeight: 800,
    },
    navigation: {
      buttonOptions: {
        align: 'right',
        y: -10
      }
    },
    series: []
  };
  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.rol = localStorage.getItem('rol');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.stationId = localStorage.getItem('idStation');
    this.idStation = localStorage.getItem('idStation');
    if (this.listDemo.includes(this.stationId)) {
      this.rol = 'Gaspre';
    }
    this.event$ = this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.route = /[^/]*$/.exec(event.url)[0];
      }
    });

    this.productType$ = this.sharedService.sharedProductTypeTotal.subscribe(productType => {
      if (this.productType !== productType) {
        this.productType = productType;
        if (this.reqst > 1) {
          this.v2 ? this.setDataV2() : this.setData();
        }
      }
    });

    this.idStation$ = sharedService.sharedStation.subscribe((station: string) => {
      if(station !== this.idStation && station) {
        this.idStation = station;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.stationId$ = this.sharedService.sharedStationId.subscribe(stationId => {
      if (this.stationId !== stationId) {
        this.stationId = stationId;
      }
    });

    this.changeModal$ = this.sharedService.sharedChangeModal.subscribe(changeModal => {
      this.changeModal = changeModal;
      if (this.changeModal === 'charts') {
        this.getDashboardSellingPricePpc();
      }
    });

    this.idGroup$ = sharedService.sharedGroup.subscribe((idGroup: string) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
        if (this.reqst > 1) {
          this.zoneSelected = '';
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.zoneSelected$ = sharedService.sharedZoneDashboard.subscribe((zone: string) => {
      if (zone === 'Total') {
        this.zoneSelected = null;
        if (zone !== this.zoneSelected) {
          this.getDashboardSellingPricePpc();
        }
      } else {
        if (zone !== this.zoneSelected) {
          this.zoneSelected = zone;
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.period$ = this.sharedService.sharedPeriodDashboard.subscribe(period => {
      if (period !== this.period) {
        this.period = period;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.days$ = this.sharedService.sharedDaysDashboard.subscribe(days => {
      if (days !== this.days) {
        this.days = days;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.weeks$ = this.sharedService.sharedWeeksAgo.subscribe(weeks => {
      if (weeks !== this.weeks) {
        this.weeks = weeks;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.months$ = this.sharedService.sharedMonthsAgo.subscribe(months => {
      if (months !== this.months) {
        this.months = months;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.importants$ = sharedService.sharedImportants.subscribe((importants: string) => {
      if (this.importants !== importants) {
        this.importants = importants;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.selectedCluster$ = sharedService.sharedSelectedComplementClusters.subscribe((selectedCluster: any) => {
      if (selectedCluster !== this.selectedCluster) {
        this.selectedCluster = selectedCluster;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.selectedCluster2$ = sharedService.sharedSelectedComplementClusters2.subscribe((selectedCluster2: any) => {
      if (selectedCluster2 !== this.selectedCluster2) {
        this.selectedCluster2 = selectedCluster2;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.selectedCluster3$ = sharedService.sharedSelectedComplementClusters3.subscribe((selectedCluster3: any) => {
      if (selectedCluster3 !== this.selectedCluster3) {
        this.selectedCluster3 = selectedCluster3;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });

    this.selectedCluster4$ = sharedService.sharedSelectedComplementClusters4.subscribe((selectedCluster4: any) => {
      if (selectedCluster4 !== this.selectedCluster4) {
        this.selectedCluster4 = selectedCluster4;
        if (this.reqst > 1) {
          this.getDashboardSellingPricePpc();
        }
      }
    });
  }

  ngOnInit() {
    this.getDashboardSellingPricePpc();
  }

  ngOnDestroy(): void {
    this.changeModal$.unsubscribe();
    this.days$.unsubscribe();
    this.event$.unsubscribe();
    this.idGroup$.unsubscribe();
    this.importants$.unsubscribe();
    this.months$.unsubscribe();
    this.period$.unsubscribe();
    this.productType$.unsubscribe();
    this.selectedCluster$.unsubscribe();
    this.selectedCluster2$.unsubscribe();
    this.selectedCluster3$.unsubscribe();
    this.selectedCluster4$.unsubscribe();
    this.stationId$.unsubscribe();
    this.weeks$.unsubscribe();
    this.zoneSelected$.unsubscribe();
  }

  getDashboardSellingPricePpc() {
    this.reqst = 1;
    let typeValue = 'value';
    const periodMap = {
      'day': this.days,
      'week': this.weeks,
      'month': this.months
    };
    const n = periodMap[this.period];
    typeValue = (typeof n === 'number') ? 'value' : 'date';
    if(this.importants !== undefined){
      const url = this.station ?
        (this.v2 ? this.gasprecioService.getStationDashboardV2Data(this.idGroup, this.idStation, this.period, n) :
        this.gasprecioService.getDashboardSellingPricePpcStation(this.period, typeValue, n)) :
        this.gasprecioService.getDashboardSellingPricePpc(this.idGroup, this.zoneSelected, this.period, this.importants, typeValue, n, this.selectedCluster, this.selectedCluster2, this.selectedCluster3, this.selectedCluster4);

      url.subscribe({
        next: (data: any) => {
          if(this.v2){
            this.fullData = data;
            this.setDataV2();
          }else {
            const info = data;
            // Eliminar duplicados cuando el periodo es 'week'
            if (this.period === 'week') {
              this.ppc = this.gasprecioService.removeDuplicateWeeks(info['ppc'] || []);
              this.sellingPrice = this.gasprecioService.removeDuplicateWeeks(info['selling_price'] || []);
              this.minSellingPrice = this.gasprecioService.removeDuplicateWeeks(data['min_selling_price'] || []);
              this.maxSellingPrice = this.gasprecioService.removeDuplicateWeeks(data['max_selling_price'] || []);
              this.minSellingPrice3 = this.gasprecioService.removeDuplicateWeeks(data['min3_selling_price'] || []);
              this.maxSellingPrice3 = this.gasprecioService.removeDuplicateWeeks(data['max3_selling_price'] || []);
              this.suggestedPrice = this.gasprecioService.removeDuplicateWeeks(data?.['suggested_price'] || []);
            } else {
              this.ppc = info['ppc'];
              this.sellingPrice = info['selling_price'];
              this.minSellingPrice = data['min_selling_price'];
              this.maxSellingPrice = data['max_selling_price'];
              this.minSellingPrice3 = data['min3_selling_price'];
              this.maxSellingPrice3 = data['max3_selling_price'];
              this.suggestedPrice = data?.['suggested_price'];
            }
            this.setData();
          }
        }, complete: () => {
          this.reqst = 2;
        }, error: () => {
          this.reqst = 3;
        }
      });
    } else {
      this.reqst = 2;
    }
  }

  setDataV2() {
    this.reqst = 1;
    const color = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);
    const colorOrange = this.gasprecioService.getColorString(this.gasprecioService.colorsProductsLight[4]);
    const colorMin = this.gasprecioService.getColorString(this.gasprecioService.colorsMinMax[0]);
    const colorMax = this.gasprecioService.getColorString(this.gasprecioService.colorsMinMax[1]);
    const colorSuggested = this.gasprecioService.getColorString(this.gasprecioService.colorsSuggested[0]);

    const sellingPriceChartData: any = {
      name: 'Precio de Venta',
      data: this.fullData.map((v: any) => {
        const val = v.products?.[this.productType]?.selling_price;
        return val == null ? null : +val;
      }),
      color: color,
      lineWidth: 2,
      marker: { radius: 2 }
    };

    const competitorsPriceChartData: any = {
      name: 'Precio de Competencia',
      data: this.fullData.map((v: any) => {
        const val = v.products?.[this.productType]?.ppc;
        return val == null ? null : +val;
      }),
      color: colorOrange,
      lineWidth: 2
    };

    const minPriceChartData: any = {
      name: 'Precio Mín Comp',
      data: this.fullData.map((v: any) => {
        const val = v.products?.[this.productType]?.min_selling_price;
        return val == null ? null : +val;
      }),
      dashStyle: 'ShortDot',
      color: colorMin,
      lineWidth: 2
    };

    const maxPriceChartData: any = {
      name: 'Precio Máx Comp',
      data: this.fullData.map((v: any) => {
        const val = v.products?.[this.productType]?.max_selling_price;
        return val == null ? null : +val;
      }),
      dashStyle: 'ShortDot',
      color: colorMax,
      lineWidth: 2
    };

    const suggestedPriceData: any = {
      name: 'Precio Sugerido',
      data: this.fullData.map((v: any) => {
        const val = v.products?.[this.productType]?.suggested_price;
        return val == null ? null : +val;
      }),
      dashStyle: 'ShortDot',
      color: colorSuggested,
      lineWidth: 2
    };

    const lineXaxisLegendGenerator = {
      day: (v: any) => this.gasprecioService.parseDateDM(v.date.formatted),
      week: (v: any) => v.date.label,
      month: (v: any) => this.gasprecioService.parseDateM(v.date.formatted)
    };

    const lineXaxisLegend = this.fullData.map(
      lineXaxisLegendGenerator[this.period]
    );

    const xAxis = Array.isArray(this.chartOptions.xAxis) ? this.chartOptions.xAxis[0] : this.chartOptions.xAxis;
    xAxis.categories = lineXaxisLegend;

    this.chartOptions.series = this.showPriceComp
      ? [sellingPriceChartData, competitorsPriceChartData, minPriceChartData, maxPriceChartData]
      : [sellingPriceChartData, competitorsPriceChartData];

    if (this.idGroup === '6697df2bfb7789085d7d82b4') {
      this.chartOptions.series.push(suggestedPriceData);
    }

    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  setData() {
    this.reqst = 1;
    const color = this.gasprecioService.getColorString(this.gasprecioService.colorsProducts[this.gasprecioService.getProductTypeIndex(this.productType)]);
    const colorOrange = this.gasprecioService.getColorString(this.gasprecioService.colorsProductsLight[4]);
    const colorMin = this.gasprecioService.getColorString(this.gasprecioService.colorsMinMax[0]);
    const colorMax = this.gasprecioService.getColorString(this.gasprecioService.colorsMinMax[1]);
    const colorSuggested = this.gasprecioService.getColorString(this.gasprecioService.colorsSuggested[0]);

    const sellingPriceChartData: any = {
      name: 'Precio de Venta',
      data: this.sellingPrice.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      color: color,
      lineWidth: 2,
      marker: { radius: 2 }
    };

    const competitorsPriceChartData: any = {
      name: 'Precio de Competencia',
      data: this.ppc.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      color: colorOrange,
      lineWidth: 2
    };

    const lineXaxisLegendGenerator = {
      day: (v: any) => this.gasprecioService.parseDateDM(v.date),
      week: (v: any) => v.date_alias,
      month: (v: any) => this.gasprecioService.parseDateM(v.date)
    };

    const minPriceChartData: any = {
      name: 'Precio Mín Comp',
      data: this.minSellingPrice.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      dashStyle: 'ShortDot',
      color: colorMin,
      lineWidth: 2
    };

    const maxPriceChartData: any = {
      name: 'Precio Máx Comp',
      data: this.maxSellingPrice.map((v: any) => {
        if (v[this.productType] === null) {
          return null; // Devuelve null si el valor es null
        } else {
          return +v[this.productType]; // Devuelve el valor convertido a número
        }
      }),
      dashStyle: 'ShortDot',
      color: colorMax,
      lineWidth: 2
    };

    const suggestedPriceData: any = {
      name: 'Precio Sugerido',
      data: this.suggestedPrice?.map((v: any) => v[this.productType] === null ? null : +v[this.productType]),
      dashStyle: 'ShortDot',
      color: colorSuggested,
      lineWidth: 2
    };

    const lineXaxisLegend = this.ppc.map(lineXaxisLegendGenerator[this.period]);
    this.chartOptions['xAxis']['categories'] = lineXaxisLegend;
    this.chartOptions.series = this.showPriceComp ? [sellingPriceChartData, competitorsPriceChartData, minPriceChartData, maxPriceChartData] : [sellingPriceChartData, competitorsPriceChartData];
    if (this.idGroup === '6697df2bfb7789085d7d82b4') this.chartOptions.series.push(suggestedPriceData);
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  openModalChartEvol() {
    this.modalService.open(this.chartModalEvol, { windowClass: 'chartModal', centered: true });
  }

  closeModalChartEvol() {
    this.modalService.dismissAll(this.chartModalEvol);
  }

  getEvolution() {
    this.reqstEvol = 1;
    this.stationId = this.section ? localStorage.getItem('idStation') : this.stationId;
    if (!this.stationId) return;
    this.gasprecioService.getEvolPriceHistory(this.stationId).subscribe({
      next: (res) => {
        this.dataEvol = res;
        this.nameStation = this.dataEvol['client']['name'];
        this.setDataEvol();
      }, complete: () => {
        this.reqstEvol = 2;
      }, error: () => {
        this.reqstEvol = 3;
      }
    });
  }

  setDataEvol() {
    this.reqst = 1;
    const lineChartData: any = [
      {
        name: this.rol !== 'Gaspre' ? this.dataEvol['client']['name'] + ' (' + this.dataEvol['client']['brand'] + ')' : 'Tu Estación ' + ' (' + this.dataEvol['client']['brand'] + ')',
        data: this.dataEvol['client']['values'].map((v: any) => {
          if (v[this.productType] === null) {
            return null; // Devuelve null si el valor es null
          } else {
            return +v[this.productType]; // Devuelve el valor convertido a número
          }
        }),
        color: 'rgb(212, 175, 55)',
        lineWidth: 1.5,
        marker: {
          radius: 4
        }
      }
    ]

    const lineXaxisLegend: any = [];
    this.dataEvol['client']['values'].map((v: any) =>
      lineXaxisLegend.push(this.gasprecioService.parseDateDM(v['date']))
    );

    this.dataEvol['competitors'].forEach((c, index) => {
      let color = `rgb(${this.gasprecioService.colors[index + 1].r}, ${this.gasprecioService.colors[index + 1].g}, ${this.gasprecioService.colors[index + 1].b})`;
      lineChartData.push({
        name: this.rol !== 'Gaspre' ? c['name'] + ' (' + c['brand'] + ')' : 'Competitor ' + (index + 1) + ' (' + c['brand'] + ')',
        data: c['values'].filter((type: any) => type !== null).map((v: any) => {
          if (v[this.productType] === null) {
            return null; // Devuelve null si el valor es null
          } else {
            return +v[this.productType]; // Devuelve el valor convertido a número
          }
        }),
        color: color
      });
    })

    this.chartEvolOptions['xAxis']['categories'] = lineXaxisLegend;
    this.chartEvolOptions['series'] = lineChartData;
    setTimeout(() => {
      this.reqst = 2;
    }, 100);
  }

  generateImageChart() {
    const canvas4: any = document.getElementById('mychart4');
    const imgData4 = canvas4.toDataURL('image/png');
    this.sharedService.nextImgData4 = imgData4;
  }
}
